import {useMainTranslation} from "../../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useReports} from "../../../hooks/useReports";
import {useReportDialogs} from "../../../hooks/useReportDialogs";
import {useSetBreadcrumbs} from "../../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import {PATH_LOCAL_COMPLIANCE_REPORTS} from "../../../../../../newShared/constants";
import {CommonFilterType, minMaxLoadedPageType} from "../../../../../../newShared/components/genericTable/types";
import {cleanAction, setMinMaxLoadedPageGeneratedReports} from "../../../store/reports/store";
import {useDispatch} from "react-redux";

export const useArchivedReportsPage = () => {
    const dispatch = useDispatch();
    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});

    const {
        archivedReports: {reports, isLoading, pageInfo, minMaxLoadedPage},
        goToCreateReport, goToReport,
        getArchivedReports,
    } = useReports();
    const {
        archiveReport: {setArchiveReportDialog},
        deleteReport: {setDeleteReportDialog},
    } = useReportDialogs();
    // const {filter} = useParameters();

    //Controller and first loadData
    const controller = new AbortController();

    //Breadcrumbs
    useSetBreadcrumbs([
        {
            title: tMenu('Reports'),
            path: PATH_LOCAL_COMPLIANCE_REPORTS,
        },
        {
            title: tMenu('Archived reports'),
        },
    ]);

    //Pagination and filtering
    // const {bottomLoader, onScroll, scrollRef} = useScrollPagination({
    //     getData: ({page, count}) => {
    //         getArchivedReports({
    //             page, count, filters: {}
    //         }, false, controller.signal)
    //     },
    //     arrayLength: reports.length,
    //     isLoading: isLoading,
    //     pageInfo: pageInfo,
    //     cleanData: cleanArchivedReports,
    //     controller: controller,
    //     isOnTop: true,
    //     // isNoMoreThanTotal: true,
    //     // customDependencies: [],
    // })

    // const {value, handleChange} = useSearchFieldURL({wait: 0});
    // const {setFilter, handleKeyDown} = useFilterUrl({
    //     getData: (filters) => {getArchivedReports({page: 0, count: pageInfo.count, filters}, true, controller.signal)}
    // });

    return {
        goToCreateReport, goToReport,
        setArchiveReportDialog, setDeleteReportDialog,
        isLoading,
        reports,
        // filter,
        // value, handleChange, handleKeyDown, setFilter,
        // bottomLoader, onScroll, scrollRef,
        genericTable: {
            paging: {
                pageInfo,
                isLoading,
                minLoadedPage: minMaxLoadedPage.minLoadedPage,
                maxLoadedPage: minMaxLoadedPage.maxLoadedPage,
                setMinMaxLoadedPage: (data: minMaxLoadedPageType) => dispatch(setMinMaxLoadedPageGeneratedReports(data)),
                clearRows: () => dispatch(cleanAction('generatedReports')),
                fetchPaging: (page: number, count: number, filters: CommonFilterType, search: string) => {
                    getArchivedReports({page, count, filters}, false, controller.signal)
                },
            }
        }
    }
}